import { SceneDraggable } from "GameObjects/StoryGame/SceneDraggable";
import { MathUtils, PixiUtils, PointUtils, RectUtils } from "html-living-framework";
import { add } from "html-living-framework/lib/Utils/PointUtils";

export class Ribbon extends SceneDraggable {
    protected cancelSelectionWhenAnotherDragStarts = false;
    protected spriteOffset: PIXI.Point = new PIXI.Point();
    protected direction: PIXI.Point = new PIXI.Point();
    protected targetPos: PIXI.Point = new PIXI.Point();
    protected targetMagnitude: number = 0;

    constructor() {
        super();
        this._outlineFilter.enabled = false;
    }

    public setEndPoint(pPoint: PIXI.Point) {
        this.targetPos = PointUtils.subtract(pPoint, this.position);
        const targetMagnitude = PointUtils.magnitude(this.targetPos);
        this.direction = PointUtils.multiply(this.targetPos, (1 / targetMagnitude));

        // not sure if this is a hack or if it's actually the correct solution...
        this.targetMagnitude = targetMagnitude / this.scale.x;
    }

    setProgress(pPercent: number) {
        this._visuals.position.copyFrom(PointUtils.multiply(this.direction, pPercent * this.targetMagnitude));
    }

    dragEnd() {
        super.dragEnd();
        this.setProgress(0);
        PubSub.publishSync('ribbon progress', {target: this, progress: 0});
    }

    protected snapToMouse(): void {
        // constrain position to line
        const magnitude = MathUtils.clamp(PointUtils.magnitude(this._eventData!.getLocalPosition(this._visuals.parent)), 0, this.targetMagnitude);
        const newPos = PointUtils.multiply(this.direction, magnitude);
        this._visuals.position.copyFrom(newPos);

        const progress = (magnitude / this.targetMagnitude);

        PubSub.publishSync('ribbon progress', {target: this, progress});

        if (progress >= 1) {
            this.deselect();
            PubSub.publishSync('ribbon complete', {target: this, progress});
        }
    }

}